import React, { useEffect, useState, useCallback, useContext } from 'react';
import item_api from '../apis/includes/item_api';
import debounce from 'lodash.debounce';
import Model from './models/QuantityModel'; // Import the Modal component
import { CartContext } from '../context/CartContext';
import loader from '../assets/images/loader.gif'

const Products = () => {
  const cartContext = useContext(CartContext);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState(0);
  const [actual_cost, setActualCost] = useState(0);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState('item_id'); // Initialize with a default value

  const user = JSON.parse(localStorage.getItem("user"));

  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    fetchProducts(searchQuery);
  }, [selectedFilter]); // Include selectedFilter in dependency array

  const fetchProducts = async (query = '') => {
    setLoading(true);
    setError(null);
    const params = {
      shop_id: user.shop_id
    };
    if (selectedFilter) {
      params[selectedFilter] = query;
    }
    try {
      const response = (await item_api.get_items(params)).data;
      setAllProducts(response);
      setProducts(response);
      if (cartContext.cartItems.length > 0) {
        console.log(response)
        console.log(cartContext.cartItems)
        const cartItemIds = cartContext.cartItems.map(item => item.item_id);
        setProducts(response.filter(item => !cartItemIds.includes(item.id)));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchProducts = useCallback(debounce(fetchProducts, 300), [selectedFilter]); // Include selectedFilter in useCallback dependencies

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    debouncedFetchProducts(query);
  };

  const openModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const addToCart = (e) => {
    e.preventDefault();
    console.log(selectedProduct)
    // Calculate total amount
    const totalAmount = amount * selectedProduct.selling_price_per_unit;
    const totalCost = amount * selectedProduct.actual_price_per_unit;

    // Create a new object to avoid mutating selectedProduct directly
    const updatedProduct = {
      ...selectedProduct,
      neededAmount: amount,
      num_of_items: amount,
      total_price_per_units: totalAmount.toFixed(2), // Ensure 2 decimal places
      total_cost_per_units: totalCost.toFixed(2)
    };

    // Add the updated product to the cart context
    cartContext.addItem(updatedProduct);
    removeDuplicates(selectedProduct);
    setAmount(0);
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const removeDuplicates = (item) => {
    setProducts(products.filter(i => i.id !== item.id));
  };

  const checkForDuplicates = async (e) => {
    e.preventDefault();
    await fetchProducts(searchQuery)
    const cartItemIds = cartContext.cartItems.map(item => item.item_id);
    setProducts(allProducts.filter(item => !cartItemIds.includes(item.id)));
  };

  const closeModal = (e) => {
    e.preventDefault();
    setAmount(0);
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const OutOfStockErrorAlert = () => {
    return (<div id="alert-border-2" className="flex items-center p-4 mb-4 text-red-800 border-t-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800" role="alert">
      <svg className="flex-shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
      </svg>
      <div className="ms-3 text-sm font-medium">
        Oops!! Selected item is out of stock! ❌🔑
      </div>
    </div>)
  }

  return (
    <div className="m-5 p-0 border-gray-300">
      <div className="flex justify-between items-center py-4 w-full">
        <form className="flex space-x-2 w-full" onSubmit={(e) => e.preventDefault()}>
          <div className="col-auto">
            <select
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
              id="filter-select"
              className="form-select w-auto p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm"
            >
              <option value="item_id">Filter by ID</option>
              <option value="name">Filter by Name</option>
            </select>
          </div>
          <input
            type="text"
            id="search-docs"
            name="searchdocs"
            className="form-control search-docs border px-4 py-1 flex-grow"
            placeholder="Search"
            disabled={!selectedFilter}
            onChange={handleSearch}
          />

          <button
            onClick={checkForDuplicates}
            type="submit"
            className="flex w-auto justify-center rounded-md border border-transparent bg-[#0da538] py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-[#0a7c2d] focus:outline-none focus:ring-2 focus:ring-[#0da538]"
          >
            Refresh Table
          </button>
        </form>
      </div>


      {loading ? (
        <div className="flex items-center justify-center ">
          <div role="status">
            <img src={loader} className="w-[150px] h-[150px]" alt='' />
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : error ? (
        <div className="text-center text-red-500">{error}</div>
      ) : (

        // <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-15 backdrop-blur">
        //     <div role="status">
        //       <img src={loader} className="w-[200px] h-[200px]" />
        //       <span className="sr-only">Loading...</span>
        //     </div>
        //   </div>
        // ) : error ? (


        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-600 bg-white">
            <thead className="text-xs text-gray-600 uppercase bg-white">
              <tr>
                <th scope="col" className="px-6 py-3 border">No</th>
                <th scope="col" className="px-6 py-3 border">
                  <div className="flex items-center">Product ID</div>
                </th>
                <th scope="col" className="px-6 py-3 border">
                  <div className="flex items-center">Product Name</div>
                </th>
                <th scope="col" className="px-6 py-3 border">
                  <div className="flex items-center">Type</div>
                </th>
                <th scope="col" className="px-6 py-3 border">
                  <div className="flex items-center">Stock</div>
                </th>
                <th scope="col" className="px-6 py-3 border">
                  <div className="flex items-center">Price</div>
                </th>
                <th scope="col" className="px-6 py-3 border">
                  <div className="flex items-center">Action</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={product.id} className="bg-white border-b">
                  <td scope="row" className="px-6 py-4 font-medium text-gray-600 whitespace-nowrap border">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4 border">{product.item_id}</td>
                  <td className="px-6 py-4 border">{product.name}</td>
                  <td className="px-6 py-4 border">{product.type}</td>
                  <td className="px-6 py-4 border">{product.num_of_items + " " + product.type}</td>
                  <td className="px-6 py-4 border">LKR.{product.selling_price_per_unit}</td>
                  <td className="px-6 py-4 border">
                    <center>
                      <button onClick={() => openModal(product)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#0da538"
                          className="bi bi-plus-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                        </svg>
                      </button>
                    </center>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Model isOpen={isModalOpen} onClose={closeModal}>
        {selectedProduct && (
          <div>
            <h2 className="text-xl font-bold mb-4" style={{ textAlign: 'center' }}>Product Details</h2>
            <form className="p-4 md:p-5">
              {
                selectedProduct.num_of_items * 1 < amount && (
                  <OutOfStockErrorAlert />
                )
              }
              <div className="grid gap-4 mb-4 grid-cols-2">
                <div className="col-span-2">
                  <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name:</label>
                  <input disabled type="text" name="name" id="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" value={selectedProduct.name} />
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Item ID:</label>
                  <input disabled type="text" name="price" id="price" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" value={selectedProduct.item_id} />
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Material Type</label>
                  <input disabled type="text" name="price" id="price" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" value={selectedProduct.type} />
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Selling Price</label>
                  <input disabled type="text" name="price" id="price" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" value={`LKR. ${selectedProduct.selling_price_per_unit}`} />
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Available Stock</label>
                  <input disabled type="text" name="price" id="price" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" value={selectedProduct.num_of_items + " " + selectedProduct.type} />
                </div>
                <div className="col-span-2">
                  <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Needed Amount</label>
                  <input onChange={e => setAmount(e.target.value)} type="number" name="price" id="price" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" min="0" placeholder="Enter Needed Qty" required="" />
                </div>
                {/* <div className="col-span-2">
                  <label htmlFor="description" className="block mb-2 text-lg font-medium text-gray-900 dark:text-white">Bill: RS.1000</label>
                </div> */}
              </div>
              <div className="flex justify-end gap-4">
                <button onClick={closeModal} type="button" className="text-white inline-flex items-center bg-red-700 hover:bg-red-800 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle mr-2" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                  Close
                </button>
                <button
                  onClick={addToCart}
                  disabled={amount <= 0 || amount > selectedProduct.num_of_items * 1 || (selectedProduct.type == 'QTY' && !Number.isInteger(amount*1))}
                  type="submit"
                  className="text-white inline-flex items-center bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-cart-plus mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9z" />
                    <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                  </svg>
                  Add to Cart
                </button>

              </div>
            </form>

          </div>
        )}
      </Model>
    </div>
  );
}

export default Products;
